/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Falcon documents payment type dictionary
 */
export enum FalconDocumentsPaymentType {
  None = 1,
  Cash,
  TerminalCash,
  Check,
  Transfer,
  CashAndTransfer,
  CashOnDelivery,
  CreditCard,
  Installments
}
